import { render, staticRenderFns } from "./TransactionSingle.vue?vue&type=template&id=b2b96746&scoped=true&"
import script from "./TransactionSingle.vue?vue&type=script&lang=js&"
export * from "./TransactionSingle.vue?vue&type=script&lang=js&"
import style0 from "./TransactionSingle.vue?vue&type=style&index=0&id=b2b96746&prod&scoped=true&lang=css&"
import style1 from "./TransactionSingle.vue?vue&type=style&index=1&id=b2b96746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b96746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VExpandTransition,VIcon,VRow,VTooltip})
